import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { EigeneZaehlerAuflistenGQL } from '../../generated/graphql';
import { map } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LuxonModule } from 'luxon-angular';
import { ZaehlerComponent } from '../zaehler-component/zaehler-component';

@Component({
  selector: 'app-liste-zaehler-component',
  imports: [
    FontAwesomeModule,
    LuxonModule,
    ZaehlerComponent,
  ],
  templateUrl: './liste-zaehler-component.html',
  styleUrl: './liste-zaehler-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListeZaehlerComponent {
  private readonly eigeneZaehlerAuflistenGQL = inject(EigeneZaehlerAuflistenGQL);

  protected readonly eigeneZaehler = rxResource({
    params: () => ({}),
    stream: () =>
      this.eigeneZaehlerAuflistenGQL
        .fetch()
        .pipe(map((result) => result?.data?.eigeneZaehlerAuflisten || [])),
  });
}
